{
  "pageTitle": "Obrada plaćanja",
  "noPendingHint": "Pokrenite skupljanje da uvezete račune.",
  "paymentComplete": "Plaćanje završeno",
  "progress": "Obrada {{count}} od {{total}} račun(a)...",
  "progressDot": "Obrada {{count}} od {{total}} račun(a)...",
  "cancelPayment": "Otkaži",
  "twoFaTitle": "Potrebna je 2FA potvrda",
  "twoFaPlaceholder": "Unesite OTP kod",
  "twoFaSubmit": "Potvrdi",
  "twoFaPaste": "Zalijepi",
  "twoFaCancel": "Otkaži",
  "paymentHistory": "Istorija plaćanja",
  "historyClose": "Zatvori",
  "invoicesToPay": "Računi za plaćanje",
  "historyLoading": "Učitavanje istorije plaćanja...",
  "historyFailedTitle": "Učitavanje istorije plaćanja nije uspjelo",
  "historyRetry": "Pokušaj ponovo",
  "historyEmpty": "Još nema logova plaćanja.",
  "simulated": "Simulirano",
  "invoices": "računa",
  "clickToViewLogs": "Klikni za pregled logova",
  "logDetails": "Detalji loga plaćanja",
  "logCompleted": "Završeno",
  "logFailed": "Neuspješno",
  "logCancelled": "Otkazano",
  "logMessages": "Poruke",
  "logEntries": "Unosi",
  "paymentDetails": "Detalji loga plaćanja",
  "date": "Datum",
  "status": "Status",
  "results": "Rezultati",
  "logs": "Logovi",
  "noMessages": "Nema poruka za ovaj posao.",
  "paymentFailed": "Plaćanje nije uspjelo",
  "confirmPay": "Potvrdi & Plati",
  "selectAll": "Izaberi sve",
  "deselectAll": "Poništi izbor"
}
